import CodigosHabilidadesIndex from "@/Pages/CodigosHabilidades/index.vue";
import CodigosHabilidadesForm from "@/Pages/CodigosHabilidades/CodigosHabilidadesForm.vue";

export default [
  {
    path: "/codigos-habilidades",
    name: "codigosHabilidades.index",
    component: CodigosHabilidadesIndex,
  },
  {
    path: "/codigos-habilidades/criar",
    name: "codigosHabilidades.create",
    component: CodigosHabilidadesForm,
    props: { editing: false },
  },
  {
    path: "/codigos-habilidades/:grupoId/editar",
    name: "codigosHabilidades.edit",
    component: CodigosHabilidadesForm,
    props: (route) => ({
      editing: true,
      grupoId: parseInt(route.params.grupoId, 10),
    }),
  },
];
